if (!customElements.get('anirona-product-sticky')) {
  customElements.define(
    'anirona-product-sticky',
    class AnironaProductSticky extends HTMLElement {
      connectedCallback() {
        this.handleClick = this.handleClick.bind(this);
        this.handleVariantChange = this.handleVariantChange.bind(this);
        this.queueVisibilityUpdate = this.queueVisibilityUpdate.bind(this);
        this.addEventListener('click', this.handleClick);
        window.addEventListener('scroll', this.queueVisibilityUpdate, { passive: true });
        window.addEventListener('resize', this.queueVisibilityUpdate);

        this.buttonObserver = new IntersectionObserver(this.queueVisibilityUpdate, { threshold: 0 });

        this.observePrimaryButton();
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.handleVariantChange);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        window.removeEventListener('scroll', this.queueVisibilityUpdate);
        window.removeEventListener('resize', this.queueVisibilityUpdate);
        this.buttonObserver?.disconnect();
        this.variantChangeUnsubscriber?.();
        if (this.visibilityFrame) cancelAnimationFrame(this.visibilityFrame);
      }

      observePrimaryButton() {
        this.buttonObserver?.disconnect();
        this.primaryButton = document.getElementById(this.dataset.primaryButtonId);
        if (this.primaryButton) this.buttonObserver.observe(this.primaryButton);
        this.queueVisibilityUpdate();
      }

      queueVisibilityUpdate() {
        if (this.visibilityFrame) return;
        this.visibilityFrame = requestAnimationFrame(() => {
          this.visibilityFrame = null;
          const shouldShow = this.primaryButton?.getBoundingClientRect().bottom < 0;
          this.classList.toggle('is-visible', shouldShow);
          this.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
        });
      }

      handleClick(event) {
        const stickyButton = event.target.closest('[data-sticky-submit]');
        if (!stickyButton || stickyButton.disabled) return;

        const primaryButton = document.getElementById(this.dataset.primaryButtonId);
        if (primaryButton && !primaryButton.disabled) primaryButton.click();
      }

      handleVariantChange({ data: { sectionId, html } }) {
        if (String(sectionId) !== String(this.dataset.sectionId)) return;

        const source = html.getElementById(`AnironaSticky-${sectionId}`);
        if (!source) return;

        this.innerHTML = source.innerHTML;
        this.observePrimaryButton();
      }
    }
  );
}
